import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Part number cell, linked to PIM when the API resolved an exact
 * `pim_product.identifier` into `pim_sku`. Always link from `pim_sku` — the raw
 * `part_num` is padded/pretty-printed by Epicor and will 404.
 */
const PartCell = ({ partNum, pimSku, pimName }) => {
  if (!partNum) return '—';
  const label = pimSku ? (
    <Link to={`/pim/products/${encodeURIComponent(pimSku)}`}>{partNum}</Link>
  ) : (
    partNum
  );
  if (!pimName) return label;
  return (
    <>
      {label}
      <div className="oc-hint">{pimName}</div>
    </>
  );
};

export default PartCell;
